import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import ThemeToggle from "@/components/ThemeToggle";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/pricing", label: "Pricing" },
  { to: "/examples", label: "Examples" },
  { to: "/help", label: "Help" },
];

export default function PublicHeader() {
  const { user } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 h-16 border-b border-border/60 glass bg-background/70">
      <div className="max-w-7xl mx-auto h-full px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <Link to="/" data-testid="brand-home" className="min-w-0 shrink"><Logo className="!h-11 sm:!h-12 md:!h-11" /></Link>
        <nav className="hidden md:flex items-center gap-1">
          {LINKS.map((l) => <Link key={l.to} to={l.to} data-testid={`link-${l.label.toLowerCase()}`} className="px-3.5 py-2 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">{l.label}</Link>)}
        </nav>
        <div className="flex shrink-0 items-center gap-1 sm:gap-2">
          <ThemeToggle />
          {user ? (
            <Link to="/app" data-testid="go-dashboard" className="rounded-xl bg-primary text-primary-foreground px-4 py-2 text-sm font-semibold hover:opacity-90">Dashboard</Link>
          ) : (
            <>
              <button data-testid="header-login" onClick={() => nav("/login")} className="hidden sm:inline-flex rounded-xl border border-border px-4 py-2 text-sm font-semibold hover:bg-accent">Log in</button>
              <button data-testid="header-signup" onClick={() => nav("/register")} className="rounded-xl bg-primary text-primary-foreground px-3 sm:px-4 py-2 text-xs sm:text-sm font-semibold hover:opacity-90">Get started</button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
